/**
 * Google Drive folder holding the ready-to-post promo videos for the
 * "Viralize em 4 Semanas" course. Affiliates download from here and post the
 * clips on their own social accounts alongside their referral link.
 *
 * The videos are hosted on Drive on purpose — they are not bundled under
 * `public/videos/`, so swapping or adding a clip needs no deploy and no R2
 * upload (see the CDN/static-assets rules in CLAUDE.md).
 */
export const VIRALIZE_PROMO_MATERIALS_URL =
  'https://drive.google.com/drive/folders/1iss0VTae1N6U-JTbNXVUC3R89CofGX0F';

/** Whether the promo-materials card has a destination to link to. */
export function hasPromoMaterials(url: string = VIRALIZE_PROMO_MATERIALS_URL): boolean {
  return url.trim().length > 0;
}
